module.exports = __webpack_public_path__ + "img/catIcon.75193df3.png";